/* =====================================================================
   CÉLA — Faire défiler les rangées à la souris (thème v17)
   Les flèches de navigation sont retirées du site. Les rangées horizontales
   (avis, « Vous aimerez aussi », galerie produit, résultats de recherche)
   se parcourent au trackpad, au doigt, ou en cliquant-glissant à la souris.
   ===================================================================== */
(function () {
  if (window.celaGlisser) return;
  window.celaGlisser = true;

  var SEL = '.cad__track, .csg__track, .predictive-search-results__wrapper-products, slideshow-slides';
  var drag = null;

  function scrollable(el) {
    return el && el.scrollWidth > el.clientWidth + 4;
  }

  function settle(el, snap, behavior) {
    var max = el.scrollWidth - el.clientWidth;
    var pad = parseFloat(getComputedStyle(el).scrollPaddingLeft) || 0;
    var box = el.getBoundingClientRect();
    var best = null;
    Array.prototype.forEach.call(el.children, function (c) {
      var pos = c.getBoundingClientRect().left - box.left + el.scrollLeft - pad;
      pos = Math.max(0, Math.min(max, pos));
      if (best === null || Math.abs(pos - el.scrollLeft) < Math.abs(best - el.scrollLeft)) best = pos;
    });
    if (best !== null) el.scrollTo({ left: best, behavior: 'smooth' });
    setTimeout(function () {
      el.style.scrollSnapType = snap;
      el.style.scrollBehavior = behavior;
    }, 450);
  }

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    if (!e.target.closest || e.target.closest('input, textarea, select, [contenteditable]')) return;
    var el = e.target.closest(SEL);
    if (!scrollable(el)) return;
    drag = { el: el, id: e.pointerId, x: e.clientX, left: el.scrollLeft, moved: false };
  });

  document.addEventListener(
    'pointermove',
    function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x;
      if (!drag.moved) {
        if (Math.abs(dx) < 6) return;
        drag.moved = true;
        drag.snap = drag.el.style.scrollSnapType;
        drag.behavior = drag.el.style.scrollBehavior;
        drag.el.style.scrollSnapType = 'none';
        drag.el.style.scrollBehavior = 'auto';
        drag.el.classList.add('is-grabbing');
        document.documentElement.classList.add('cela-grabbing');
      }
      drag.el.scrollLeft = drag.left - dx;
      e.preventDefault();
    },
    { passive: false }
  );

  function end() {
    if (!drag) return;
    var d = drag;
    drag = null;
    if (!d.moved) return;
    d.el.classList.remove('is-grabbing');
    document.documentElement.classList.remove('cela-grabbing');
    settle(d.el, d.snap, d.behavior);
    // Le clic qui suit un glissé n'ouvre pas le produit ni la photo
    var stop = function (ev) {
      ev.preventDefault();
      ev.stopPropagation();
    };
    window.addEventListener('click', stop, { capture: true, once: true });
    setTimeout(function () {
      window.removeEventListener('click', stop, true);
    }, 60);
  }

  document.addEventListener('pointerup', end);
  document.addEventListener('pointercancel', end);

  // Sans ça, le navigateur « attrape » l'image au lieu de faire défiler la rangée
  document.addEventListener('dragstart', function (e) {
    if (e.target.closest && e.target.closest(SEL)) e.preventDefault();
  });
})();
